import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-24 px-4 bg-white" data-id="element-133">
      <div className="max-w-2xl mx-auto" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-8 text-lg md:text-xl leading-relaxed text-[#2D2A26]/90 font-light" data-id="element-135">
          <h2 className="text-3xl md:text-4xl font-serif text-[#2D2A26] mb-12 text-center" data-id="element-136">
            Te pasa así:
          </h2>

          <p data-id="element-137">Una semana estás “bien”.</p>

          <p data-id="element-138">
            A la siguiente, tu cara amanece roja, con textura rara… y un brote
            que no pediste.
          </p>

          <div className="pl-6 border-l-2 border-[#C4A08A]/30 italic text-[#8B7355]" data-id="element-139">
            <p data-id="element-140">
              Entonces haces lo lógico (lo que nos enseñaron): compras algo más
              fuerte, exfolias “para limpiar”, cambias la crema… y esperas que
              se arregle.
            </p>
          </div>

          <p data-id="element-141">Pero en lugar de arreglarse, tu piel se vuelve más sensible.</p>

          <p className="font-medium text-[#2D2A26]" data-id="element-142">Y ahí empieza el ciclo:</p>

          <div className="flex items-center justify-center py-6" data-id="element-143">
            <div className="text-center space-y-2 font-serif text-xl md:text-2xl text-[#C4A08A]" data-id="element-144">
              <p data-id="element-145">más rojez → más ansiedad</p>
              <p data-id="element-146">↓</p>
              <p data-id="element-147">menos tolerancia ← más productos</p>
            </div>
          </div>

          <p data-id="element-148">
            <strong className="font-semibold text-[#2D2A26]" data-id="element-149">
              PIEL EN PERI
            </strong>{' '}
            es un protocolo de 21 días para salir de ese ciclo sin volverte
            experta, sin 12 pasos, y sin vivir “apagando incendios” todas las
            semanas.
          </p>
        </motion.div>
      </div>
    </section>;
}